import { render } from "./TagProjectDisplay.vue?vue&type=template&id=2c53dbc5&scoped=true"
import script from "./TagProjectDisplay.vue?vue&type=script&lang=js"
export * from "./TagProjectDisplay.vue?vue&type=script&lang=js"

import "./TagProjectDisplay.vue?vue&type=style&index=0&id=2c53dbc5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c53dbc5"]])

export default __exports__